import { render } from "./ProjectShare.vue?vue&type=template&id=e23cf83e"
import script from "./ProjectShare.vue?vue&type=script&lang=js"
export * from "./ProjectShare.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__